import React from 'react';
import PropTypes from 'prop-types';

var getFirstRelativeParent = require('../text-helpers').getFirstRelativeParent;
var DRAGIN_SUFFIX = '-draging';

/**
 * Drag item container
 * @prop {string}dndHandler class name drag handler.
 * @prop {ReactElement}dndPlaceholder dragged item placeholder
 * @prop {string}dndItemType dragged item type. Ecplain context where we can drop this item
 * @prop {object}dndDropData data whicch will be send to the target container on drop action
 * @prop {string}className item class name. "className+DRAGIN_SUFFIX" class will be added when during item drag event
 * @prop {function}dndDragCallback callback will be called when item start or stop drag
 */
var DndItem = React.createClass({

  propTypes: {
    dndHandler: PropTypes.string,
    dndPlaceholder: PropTypes.element,
    dndItemType: PropTypes.string.isRequired,
    dndDropData: PropTypes.any.isRequired,
    dndDragCallback: PropTypes.func,
    dndDragClass: PropTypes.string,
    dndDragRenderCallback: PropTypes.func
  },

  contextTypes: {
    onDndItemStartDrag: PropTypes.func
  },

  getInitialState(){
    return {
      isDragging: false,
      style: {}
    }
  },

  shouldComponentUpdate(nextProps, nextState){
    if ((this.state.isDragging != nextState.isDragging) && this.props.dndDragCallback) {
      this.props.dndDragCallback(nextState.isDragging);
    }

    return true;
  },

  render(){

    var self = this, itemClass = {};
    var {dndDragClass, className} = this.props;

    if (dndDragClass) {
      itemClass[dndDragClass] = true;
      itemClass[dndDragClass + DRAGIN_SUFFIX] = this.state.isDragging;
    }

    return (
      <div ref="DndItem" className={className}>
        {this._getItemPlaceholderContent()}
        <div
          className={classnames(itemClass)}
          onMouseDown={this._startDrag}
          onTouchStart={this._touchStart}
          style={this.state.style}>
          {this.getDragContentContent()}
        </div>
      </div>
    )
  },

  getDragContentContent(){
    var {isDragging} = this.state;

    if (!isDragging) {
      return this.props.children;
    }

    var {dndDragRenderCallback} = this.props;

    var content = (typeof dndDragRenderCallback == "function") ? dndDragRenderCallback() : null;

    return content || this.props.children;
  },

  _getItemPlaceholderContent(){
    return this.state.isDragging && this.props.dndPlaceholder
      ? this.props.dndPlaceholder
      : null;
  },

  _touchStart(event){
    var touches = event.touches;
    if (touches.length != 1) return;
    event.stopPropagation();
    this._startDrag(touches[0], true);
  },

  _startDrag(event, isTouch){

    if (event.button !== 0 && !isTouch) {
      return;
    }

    if (this.props.dndHandler && event.target.className.indexOf(this.props.dndHandler) < 0) {
      return;
    }

    if (!isTouch) {
      event.stopPropagation();
    }

    var rect = this.refs.DndItem.getBoundingClientRect(),
      relativeParentRect = this._getRelativeParentRect(),
      eventCoordinates = {
        deltaX: (event.clientX - rect.left) + (relativeParentRect ? relativeParentRect.left : 0),
        deltaY: (event.clientY - rect.top) + (relativeParentRect ? relativeParentRect.top : 0),
        clientX: event.clientX,
        clientY: event.clientY,
        originalRelativeParentTop: relativeParentRect.top
      };

    this.context.onDndItemStartDrag(
      this.props.children,
      eventCoordinates,
      this.props,
      this._updateItemState,
      event.currentTarget
    );
  },

  _updateItemState(state){
    this.setState(state);
  },

  _getRelativeParentRect(){
    var parent = getFirstRelativeParent(this.refs.DndItem);
    if (!parent) {
      return null;
    }
    const parentRect = parent.getBoundingClientRect();
    parentRect.scrollTop = parent.scrollTop;
    return parentRect;
  }
});

module.exports = DndItem;
